import axios from "axios";

const api = axios.create({
  baseURL: "/",          // ← ver nota al final si "no sale nada"
  withCredentials: true, // manda la cookie access_token automáticamente
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    const status = error.response?.status;

    // Peticiones marcadas como manuales: las maneja el componente.
    if (config?.meta?.triggeredByButton) {
      return Promise.reject(error);
    }

    // Rutas de auth: aquí NO refrescamos ni redirigimos (evita bucles).
    const url = config?.url || "";
    const esRutaAuth =
      url.includes("/login/token/refresh") ||
      url.endsWith("/login/") ||
      url.includes("/roledash") ||
      url.includes("/logout");

    if (status === 401) {
      // 1) Un solo intento de refresh (para expiración normal del access token).
      if (!config._retry && !esRutaAuth) {
        config._retry = true;
        try {
          await api.post("/login/token/refresh/"); // usa la cookie refresh_token (endpoint del backend)
          return api(config);                        // reintenta la petición original
        } catch (e) {
          // refresh falló (sesión matada o refresh vencido) → caemos a login
        }
      }
      // 2) Sin salvación → a login. El reload resetea Pinia (no hace falta clear()).
      if (window.location.pathname !== "/index") {
        window.location.href = "/index";
      }
      return Promise.reject(error);
    }

    // 403 (sin permiso en una peticion): NO mostramos alert global aqui.
    // Cada vista maneja su propio 403 (ej. GeneracionProyecto con su swal).
    // El aviso de "sin permiso" al entrar a una ruta lo maneja el guard.

    return Promise.reject(error);
  }
);

export default api;
